var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M29.993 39c1.628 0 2.87-.395 3.725-1.185S35 35.872 35 34.355V5.645c0-1.517-.427-2.67-1.282-3.46S31.62 1 29.993 1H10.007c-1.628 0-2.87.395-3.725 1.185S5 4.128 5 5.645v28.71c0 1.517.427 2.67 1.282 3.46S8.38 39 10.007 39h19.986zm-.038-.974h-19.91c-1.316 0-2.314-.313-2.992-.938-.68-.625-1.019-1.55-1.019-2.775V5.687c0-1.212.34-2.134 1.019-2.765.678-.632 1.676-.948 2.992-.948h19.91c1.316 0 2.314.316 2.992.948.68.631 1.019 1.553 1.019 2.765v28.626c0 1.225-.34 2.15-1.019 2.775-.678.625-1.676.938-2.992.938zm-4.757-.996a.493.493 0 00.348-.133.425.425 0 00.144-.323.446.446 0 00-.144-.343.493.493 0 00-.348-.133H14.823a.525.525 0 00-.37.133.449.449 0 00-.143.343c0 .126.048.234.144.323a.521.521 0 00.369.133h10.375z"
  }))));
}

export default SvgTablet;